module.exports = __webpack_public_path__ + "static/media/appsumo.18543264.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/appsumo.png
// module id = 2174
// module chunks = 30